import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

/**
 * Renders a trail of links ending in the current page.
 *
 * items: [{ label: string, to?: string }]
 * The last item (or any item without `to`) renders as plain text.
 */
function Breadcrumb({ items }) {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="breadcrumb-item">
            {item.to && !isLast ? (
              <Link to={item.to}>{item.label}</Link>
            ) : (
              <span className="breadcrumb-current">{item.label}</span>
            )}
            {!isLast && <span className="breadcrumb-sep" aria-hidden="true">/</span>}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
